import { Component, inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'lc-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [MatProgressSpinner, AsyncPipe],
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);

  color = 'primary';
  mode = 'indeterminate';
  value = 50;

  isLoading = this.loaderService.isLoading;
}
